export default {
  msg: {
    //countdown / time
    seconds: "Segundos",
    minutes: "Minutos",
    hours: "Horas",
    days: "Dias",

    //titles / sub
    insights: "Insights",
    fund_holdings: "Holdings",
    charity: "Caridade",
    charity_sub: "A Stratum doou o seguinte para caridade.",
    network_distributions: "Distribuições de Rede",
    network_distributions_sub:
      "Moedas ganhas em distribuições de rede, como airdrops.",
    redemption_sub:
      "Operação para liquidar BLUE e receber o valor equivalente em Tether (USDT), stablecoin a par com o dólar americano.",
    twofa_info: "Para resgatar, tem de ativar o 2FA.",
    redemption_sub_one:
      "Resgates estão disponíveis às quartas-feiras, das 0h às 17h (UTC -3), e demoram 3 dias úteis para serem creditados (D+3).",
    redemption_sub_two:
      "Uma opção de pagamento no mesmo dia está disponível por uma taxa.",
    redemption_sub_three: "Resgates são pagos através da rede Tron (TRC-20).",

    //a
    alert_created_deposit:
      "Sua carteira ja foi  criada, por favor atualize a pagina.",
    alert: "Alerta",
    asset_allocation: "Alocaçação de Criptomoeda",
    amount_below_purchase_limit: "Valor abaixo do limite mínimo de compra",
    amount_below_minimum_trade_limit:
      "Montante abaixo do limite mínimo de negociação",
    activating_account: "Por favor aguarde. Estamos a activar a conta…",
    activation_successful:
      "Parabéns, a sua conta está agora activa. Pode fazer a autenticação.",
    activation_successful_2fa:
      "Parabéns, o seu código 2fa está agora ativo. Pode prosseguir para os serviços.",
    activation_link_invalid: "O link de ativação é inválido",
    apply_filter: "Aplicar filtro",
    add_funds: "Adicionar BLUE",
    address: "Endereço",
    actions: "Ações",
    action: "Açõe",
    all: "Todos",
    all_rights_reserved: "Todos os direitos reservados",
    all_transactions: "Todas as transacções",
    already_member: "Já é membro?",
    amount: "Montante",
    approx_value: "Valor aproximado",
    equivalent_in: "Equivalente em",
    one_blu_equals: "1 BLUE igual",
    equivalence: "Equivalência",
    one_blu: "1 BLUE",
    updated_last: "Última atualização",
    all_time: "Todas as vezes",
    activate: "Activar",
    available_info: "Disponível para resgate",
    available_to_redeem: "Disponível para resgate: {amount} USDT",
    available: "Disponível",
    attention_done: "Atenção: sua compra foi concluida",
    attention_cancel:
      "Atenção: Seu pedido foi cancelado. Se você deseja comprar BLUE, abra um novo pedido",
    attention_waiting_days: "Atenção: Seu pedido tem {hours} até o vencimento.",
    attention_waiting_hours:
      "Atenção: Seu pedido tem {hours} até o vencimento.",
    attention: "Atenção",
    available_balance: "Saldo disponível: ",
    allocation: "Alocação",
    authenticate: "Autenticar",
    address_empty: "O endereço está vazio",
    average_time: "Depósitos podem demorar até 5 minutos.",

    //b
    balance: "Saldo | Saldos",
    begins: "Começa",
    bonus: "Bónus",
    buy: "Comprar",
    buy_tokens: "Comprar BLUE",
    buyer_bonus: "Bónus do comprador",
    blank: "",
    bonus_0dot5: "Bónus(0.5%)",
    bonus_1: "Bónus(1%)",
    bonus: "Bónus",
    buy_here: "Compre Aqui",
    buy_now: "Compre Agora",
    bktc: "BKTC",
    back: "Retroceder",
    balance_equivalence: "Equivalência do saldo em",
    blue_team: "Time BLUE",
    buy_pix: "Compre BLUE via PIX",
    buy_pix_info:
      "Usando o SWAPiX, um parceiro confiável que oferece trocas fiat-para-cripto.",
    blue_club_status: "Blue Club status",

    balance_text_tusd: "TrueUSD Stablecoin aliado ao Dólar Americano",
    balance_text_btc: "Bitcoin",
    balance_text_rlt: "RealT Stablecoin aliado ao Real Brazileiro",
    balance_text_eth: "Ethereum",
    buy_token: "COMPRAR TOKEN",
    boleto: "Guia de Pagamento",
    best_way_buy: "Melhor maneira de comprar",
    browser_message:
      "Se não conseguir visualizar o documento, por favor utilize o Firefox ou o Safari.",
    business_day: "DIAS ÚTEIS",
    no_additional_fee: "Sem taxas adicionais.",
    rush_today: "RUSH (hoje)",
    receive_today_info: "Você receberá no mesmo dia do calendário.",
    basket_value: "Valor da cesta",

    //c
    charity: "Caridade",
    clear_filter: "Limpar filtro",
    cancelled: "Cancelado",
    cancel_purchase: "Cancelar compra",
    click_on_transaction_to_get_details:
      "Para obter mais detalhes, clique numa transacção.",
    chart: "Gráfico",
    crypto: "Cripto",
    copy_twofa:
      "Digitalize o código QR com o seu telemóvel usando o Google Authenticator ou o Authy, ou então digite o código.<strong>Para o caso de perda do seu telefone, mantenha esse código num local seguro e não o partilhe com ninguém.</strong>",
    confirm_delet: "Tem certeza?",
    click_here: "Entrar na Stratum smartwallet",
    confirm_redeem: "O seu resgate está a ser processado.",
    confirm_withdraw: "O seu levantamento está a ser processado.",
    amount_revice_withdraw: "Valor a receber",
    amount_revice_withdraw_fee: "Taxa: ",
    can_not_load_data: "Não é possível carregar os dados.",
    change: "Alteração",
    coin_slider_BTC: "Bitcoin",
    coin_slider_RAS: "Ras – Stablecoin a par com o Real Brazileiro",
    coin_slider_BLU: "TrueUSD – Stablecoin a par com o Dólar Americano",
    coin_slider_ETH: "Ethereum",
    coin_slider_ZAR: "RAND – Moeda da África do Sul",
    coin_slider_EUR: "Euro – Moeda da União Europeia",
    coin_slider_GBP: "Libra Esterlina – Moeda do Reino Unido",
    coin_slider_CHF: "Franco Suíço – Moeda da Suíça",
    coin_slider_CNY: "Yuan – Moeda da China",
    coin_slider_HKD: "HK$ - Moeda do Dólar de Hong Kong",
    coin_slider_USDT: "USDT – Stablecoin a par com o Dólar Americano",
    cancel: "Cancelar",
    contact_us_any_question:
      "Sinta-se à vontade para nos contatar em support@bluetoken.io se tiver alguma dúvida.",
    cellphone: "Telemóvel",
    cpf: "CPF",
    cep: "CEP",
    complement: "Complemento",
    city: "Cidade",
    criptocurrency: "Criptomoeda",
    chose_two_coins:
      "O retorno mostrado é no acumulado do ano, até 23 de Dezembro do 2022",
    click_here_to_vote: "Clique aqui para votar",
    copy_address: "Copiar Endereço",
    create_order: "Criar novo pedido",
    cancel_transaction: "Cancelar transacção",
    canceling_order: "Pedido cancelado ",
    canceling: "Cancelado",
    checking_open_orders: "Verificando pedidos em aberto",
    copy_alert_info_otc: "Copiado - valor esperado e valor estimado",
    confirm_recaptcha: "Confirme o CAPTCHA",
    create_deposit_address: "Criar endereço de deposito",
    check_info_redeem: "Verifiquei que as informações acima são precisas.",
    current_value: "Valor atual",
    component_hold: "Componente",
    current_weight: "Peso atual",
    currently_generating: "Atualmente gerando recompensas diárias",
    country_residency: "País de residência",
    countries_not_allowed:
      "USA/China/HK - Países não autorizados a usar nossos serviços!",
    clain_your_nft: "Obtenha seu NFT",

    //check
    check_your_email: "Por favor, verifique o seu e-mail e siga as instruções.",
    check_your_email_for_userid:
      "Vai receber um e-mail com o seu ID de utilizador.",
    check_your_email_for_recovery_link:
      "Vai receber um e-mail com o link de recuperação.",
    check_your_email_for_pin:
      "Vai receber um e-mail com o PIN para confirmar a transacção",
    check_your_email_for_pin_redeem:
      "Vai receber um e-mail com o PIN para confirmar a transacção",
    if_no_email_spam:
      "Caso não consiga encontrar o e-mail, por favor verifique a sua caixa de spam.",
    closes: "Fechos",
    component: "Componente | Componentes",
    confirm: "Confirme",
    confirm_operation: "Confirmar Operação",
    confirmation_pin: "Confirme o seu PIN",
    confirmation_pin_email_hint:
      "Após a continuação, irá receber um e-mail com o PIN de confirmação, necessário para concluir a sua operação.",
    contact: "Contacto",
    continue: "Continuar",
    copied: "Copiado",
    copy: "Copiar",
    currency: "Moeda",
    click_here_action: "Clique aqui",
    change_withdraw_partner: "Escolha a entidade de levantamento",

    //d
    denied: "Negado",
    dashboard: "Painel de Controle",
    dont_have_btc: "Não tem Bitcoin?",
    details: "Detalhes",
    deposits: "Depósitos",
    deposit_amount: "Valor do depósito",
    dear_blu_holder: "Caro titular do BLUE",
    district: "Distrito",
    donwload: "Donwload",
    documentation_info:
      "Fichas técnicas, métodos, cálculos e outros documentos",
    dropdown_header_withdraw: "Envie seus tokens para uma carteira externa",
    dropdown_header_deposit: "Receba seus tokens de uma carteira externa",
    dropdown_header_redeem: "Troque seus tokens",
    dropdown_header_internal: "Envie BLUE para outro usuário",
    destination_user: "Usuario de destino",
    deposit_received: "Seu depósito foi recebido",
    do_you_want: "Deseja cancelar mesmo assim?",
    download_pdf: "Baixar PDF",
    deposit_sub:
      "O depósito é uma operação que permite receber o {coin} de uma carteira externa.",
    internal: "Transferência interna",
    delivery_speed: "Velocidade de entrega",
    download_csv: "Baixar CSV",

    //dates
    date_1: "4 de Dezembro, 2018",
    date_2: "15 de Janeiro, 2019",
    date_3: "16 de Janeiro, 2019",
    date_4: "15 de Fevereiro, 2019",
    date_5: "16 de Fevereiro, 2019",
    date_6: "6 de Abril, 2019",
    date_7: "11 de Abril, 2019",

    days_remaining: "Dias restantes",
    deposit: "Depósito",
    disclaimer: "Aviso Legal",
    documentation: "Documentação",

    //e
    expire_in: "Expirar em",
    expired: "Expirado",
    earn_on_referrals: "Ganhe com Indicados",
    earn_bonus_tooltip: "Bónus ganhos com o programa de Indicados.",
    email: "E-Mail",
    equals: "Equivalente",
    expired: "Expirado",
    export_csv: "Exportar CVS",
    ends: "Termina",
    explorer: "Explorador",
    equivalent: "Equivalente",
    equivalent_to: "Equivalente a",
    expired_pin: "Pin expirado",
    enable_2fa: "Activar 2FA",
    eth_contract_message: "Não envie Ether usando um Smart Contract",
    clicl_expand: "Click para expandir",
    expand_chart: "Expandir gráfico",
    estimated_info_modal_equivalent:
      "Valor estimado com base na troca Tether com outras moedas",

    //error_message
    error: "Erro",
    error_create_address: "Erro ao criar o endereço, tente mais tarde",
    error_redeem: "Houve um erro com o seu pedido.",
    error_redeem_amount:
      "Verifique se tem saldo suficiente disponível e se o valor solicitado está acima do mínimo.",
    error_redeem_amount_no_funds:
      "Não possui fundos suficientes desbloqueados para realizar esta operação",
    error_redeem_amount_below_min:
      "A quantia DEVE estar acima do mínimo exigido.",
    error_redeem_address:
      "Certifique-se que está a usar um endereço de BTC válido.",
    error_withdraw_address:
      "Certifique-se que está a usar um endereço de BLUE válido.",
    error_redeem_confirm: "Ocorreu um erro, verifique os campos.",
    error_internal_member_not_found: "ID do usuário não encontrado",
    error_pool_avatar: "Avatar ja existente.",
    error_pool_avatar_select:
      "Você precisa escolher um nome e ícone de avatar.",

    //f
    faq: "FAQ",
    fee: "Taxa | Taxas",
    fees_minimums: "Taxas & Mínimos",
    forgot_password: "Esqueceu-se da palavra-passe",
    forgot_userid: "Esqueceu-se do ID de utilizador",

    fees_minimum_amount: "Taxa é de 2 USDT do valor, com um mínimo de 2 USDT",
    fee_1dot5: "Taxa 1.5%",
    fee_2dot5: "Taxa 2.5%",
    fee_4: "Taxa 4%",
    fee_6: "Taxa 6%",
    failed: "falhou",
    fund_in_maintenance:
      "O nosso sistema está em manutenção, por favor tente a sua operação mais tarde.",
    fill_form_boleto: "Preencha o formulário para gerar a guia de pagamento",
    fill_form: "Preencha o formulário",
    fact_sheet: "Ficha informativa",
    finish_Vote: "Concluir votação",
    form_error_fields: "Todos os campos são obrigatorios!",
    found_member: "Membro encontrado",
    fee_info_redeem_one: "A taxa é ",
    fee_info_redeem_two: "de valor, com um mínimo de",
    fee_redeem_wave_info: "A taxa é de 2 USDT para resgates abaixo de 50 USDT.",
    error_xgateway:
      "Nossa rede está enfrentando problemas com a cripto selecionada. Por favor, tente novamente em alguns minutos.",

    //g
    get_pin: "Obter pin",
    global_search: "Pesquisa global",
    generate_slips: "Gerar guia de pagamento",
    g_l: "G/P",
    generating_tokens: "Gerando tokens, por favor aguarde",

    //h
    help: "Ajuda",
    history: "Histórico",
    hypothetical_portfolio: "Componentes hipotéticos sujeitos a alterações.",
    home: "Página Inicial",
    here: "aqui",
    how_vote: "Como votar?",
    header_referral: "Alguém te indicou?",
    how_it_works:
      "<a href=https://youtu.be/D8P1_01-uF4 target=_blank>Como funciona?</a>",

    //i
    input_usdt_address: "Insira o address de USDT",
    input_blue_amount: "Insira a quantidade de BLUE",
    input_amount_redeem: "Insira a quantidade de BLUE que deseja resgatar.",
    input_amount_withdraw: "Insira a quantidade de BLUE que deseja levantar.",
    input_amount_transfer:
      "Insira a quantidade de BLUE que deseja transferir para outra conta",
    info_redeem_step_3: "Para sua segurança digite o PIN e o 2fa.",
    info_redeem_address_step_4: "Endereço: ",
    info_redeem_email_step_4: "Você receberá todos os detalhes no seu e-mail.",
    info_redeem_step_4: "O processo será concluído hoje.",
    info_redeem_step_5: "O processo levará 3 dias úteis.",
    info_withdraw_step_4:
      "Aguarde até que a sua transacção seja processada pela blockchain.",
    info_2fa_tip:
      "Como medida de segurança, você deve primeiro habilitar o 2FA para transferir ou resgatar seus tokens.",
    inform_the_amount_bitcoin_address:
      "Informe o valor e o seu endereço Bitcoin",
    inform_the_amount_blu_tag: "Informe a quantiade e o Endereço BLUE",
    inform_the_amount_user_id: "Informe a quantidade BLUE e o ID do usuário",
    internal_transfer: "Transferência interna",
    internal_sub:
      "Transferência Interna é uma operação que permite enviar BLUE para outro usuário dentro da plataforma Blue.",
    internal_steps: "Etapas de transferência interna",
    internal_action_send: "Enviado",
    internal_action_receive: "Recebido",
    info_usdt_blue_purchase:
      "Envie apenas USDT para este endereço. Você deve usar a Rede Tron (TRC20).",
    input_valid_usdt: "Insira um endereço TRC20 de Tether (USDT) válido",
    send_to_my_usdt: "Enviar para minha carteira Tether",
    usdt_info_trc20:
      "Usamos a rede TRC20 da Tron. Certifique-se de inserir apenas um endereço TRC20.",
    input_text_USDT: "Insira o valor e o endereço USDT",
    input_text_invalid_USDT: "Insira o valor de USDT que você deseja retirar.",

    //insert
    insert_bitcoin_address: "Insira o endereço de Bicoin",
    insert_quantity: "Insira a quantidade",
    insert_your_pin: "Insira o seu pin",

    //invalid
    invalid_address: "Endereço inválido",
    invalid_amount: "Montante inválido",
    invalid_credentials: "Credenciais inválidas.",
    invalid_destination_address: "Endereço de destino inválido.",
    invalid_phone: "Telefone inválido.",
    invalid_phone_country: "País não autorizado a usar nossos serviços.",
    invalid_email: "E-mail inválido",
    invalid_has_accepted_terms: "Por favor, aceite os Termos e Condições.",
    invalid_is_aware_token_redemption:
      "Por favor marque a caixa de seleção acima.",
    invalid_input_amount_crypto: "Montante inválido",
    invalid_is_not_usa_citizen:
      "Confirme que não é cidadão ou residente dos Estados Unidos.",
    invalid_is_not_china_citizen:
      "Confirme que não é cidadão ou residente em Hong Kong.",
    invalid_password: "Senha inválida.",
    invalid_password_confirmation: "Confirmação de senha inválida.",
    invalid_password_old: "Senha atual inválida",
    invalid_pin: "PIN inválido.",
    invalid_referral_code: "Código de Indicados inválido.",
    invalid_userid: "Código de utilizador inválido.",
    invalid_user_id: "Código de utilizador ID inválido.",
    invalid_connetion:
      "Ocorreu um problema ao autenticar o seu pedido, verifique a sua ligação ou o seu nome utilizador.",
    invalid_2fa_code: "Código 2FA incorrecto",
    insert_referral_code: "Inserir código de referência (Opcional)",
    Invalidaddress: "Este endereço não é aceito.",

    //l
    language: "Língua | Línguas",
    launch: "Lançamento",
    launch_april: "Lançamento – ABRIL 2019",
    legal: "Legal",
    list: "Lista",
    last_update: "Última atualização",
    link_no_account:
      'Se ainda não tem uma conta Stratum, <a href="https://auth.stratum.hk/signup.php?lang=en" target="_blank"> clique aqui </a> para criar uma.',
    loading_balance: "Carregando saldo da conta...",
    live_price: "Preço ao vivo",
    last_month_blue_total: "Blue Pool pagou um total de",

    //languages
    en: "EN | Inglês",
    es: "ES | Espanhol",
    pt: "PT | Português",

    loading: "A carregar",
    loading_data: "A carregar os dados da compra",
    load_fee: "Taxa de carregamento",
    login: "Autenticação",
    login_successful: "Autenticado com sucesso",
    login_here: "Autenticação Aqui",
    logout: "Sair",
    latest: "Mais recentes",

    //m
    minimum: "Mínimo",
    money: "Dinheiro",
    masternodes: "masternodes",
    make_new_redeem: "Faça um novo resgate",
    methodology: "Metodologia",
    min_amount_is: "O montante mínimo é",
    member_not_found: "Membro não encontrado.",
    make_sure_address: "Certifique-se de usar um endereço BLUE válido.",
    my_balances: "Meus saldos",
    my_balance: "Meus saldo",
    my_total_value: "Meu saldo total",
    my_gain_loss: "Meu Ganho/Perda",
    minimum_purchase_USDT:
      "O saldo mínimo exigido é de 20 USDT. Aumente seu saldo.",
    minting: "Criando",
    member_benefits: "Benefícios de associação",
    my: "Meu",

    //n
    name: "Nome",
    name_optional: "Nome (Opcional)",
    next: "Próximo | Prox",
    no_data_found: "Nenhum dado encontrado",
    no_rec_transactions_found: "Nenhuma transacção encontrada.",
    not_enough_balance: "Sem saldo suficiente",
    not_member_yet: "Ainda não é membro?",
    next_step: "Passo seguinte",
    number: "Número",
    network: "Rede",
    notification: "Notificação",
    only_one_day: "Apenas 1 resgate por dia permitido.",

    //o
    of: "do",
    opens: "Abrir",
    open_account: "Abrir Conta",
    operations: "operações",
    Operations: "Operações",
    or: "ou",
    one_token_equivalence: "Uma equivalência BLUE em",
    optional: "Opcional",
    otc_info:
      "Forneça as informações abaixo. Nosso balcão de atendimento OTC entrará em contato para ajudá-lo com sua compra.",
    otc_thank_msg: "Nosso balcão OTC entrará em contato com você em breve.",
    otc_purcahse_info: "Informação da compra",
    otc_purcahse: "compra OTC",
    otc_purchase_info_to_user:
      "Sua compra está sendo processada por nossa mesa OTC, por favor aguarde.",

    //p
    past_2fa: "Insira aqui o código 2FA com 6 dígitos",
    pin_already_been_used: "O Pin já foi usado",
    price_graph: "Gráfico de Preços",
    portfolio_value: "Valor da Cripto-Cesta",
    pay_slip_info: "Para receber os seus BLUE, pague a guia de pagamento",
    please_chose_two_coins: "Escolha 2 criptomoedas.",
    phone_optional: "Celular",
    phone_code: "Código do país",
    phone: "Telemóvel",
    purchase_success: "Sua compra foi criada para o usuário.",
    price_history_list: "Histórico de preços",
    closing_price: "Preço final",
    pay_with_USDT: "Pague com o saldo USDT",

    //password
    change_password: "Alterar senha",
    current_password: "Senha atual",
    confirm_password: "Confirme a senha",
    new_password: "Nova senha",
    password: "Senha",
    password_create: "Criar nova senha",
    password_changed: "A senha foi alterada",
    password_requirements:
      "A senha deve conter 8 caracteres, 1 caractere especial (-_+=,<.>;:^~@#$%&*), 1 letra minúscula, 1 letra maiúscula e 1 número.",
    recover_password: "Recuperar Senha",
    recover_userid: "Recuperar ID de Utilizador",
    password_suggestion: "Utilize a senha sugerida pela Blue",
    confirm_password_error: "Confirme sua alteração de senha.",
    wrong_password_confirmation: "Confirmação de senha errada",
    phone_already_registered: "Este telefone já está cadastrado.",
    email_already_registered: "Este e-mail já está cadastrado.",

    pay_with: "Pague com cripto",
    perc_portfolio: "% da disponibilização da cesta-Cripto",
    phase: "Fase | Fases",
    portfolio: "Cesta-Cripto",
    price: "Preço",
    pre_sale: "Pré-Venda",
    preferences: "Preferências",
    preferred_language: "Língua preferida",
    previous: "Anterior | Anterior",
    privacy_policy: "Política de Privacidade",
    purchase: "Compra",
    performance: "Evolução dos Preços",
    please_verify_information: "Verifique as informações abaixo com precisão.",

    //q
    quantity: "Quantidade",

    //r
    receive_calculator_text:
      "O cálculo exclui quaisquer taxas impostas pela sua carteira e pela rede. Aconselhamos a depositar um pouco mais do que a quantia desejada.",
    receive: "Receber",
    receiving_email: "A receber e-mail",
    recent_transactions: "Transacções recentes",
    redeem: "Resgate",
    referral_award: "Prémio de Indicados",
    referrals: "Indicados",
    referral_code: "Código de Indicados",
    report: "Relatório trimestral",
    report_link_text: "Lançamento",
    report_link_download_quarter:
      "Baixe o relatório trimestral de outubro a dezembro de 2022 (T4 de 2022)",
    report_link_span:
      "Os relatórios são publicados na primeira semana de cada trimestre.",
    redemptions: "Resgates",
    redemption: "Resgate",
    redemption_info:
      "<strong>Resgates sem taxas:</strong> Qualifica-se para resgate até <strong>50 BLUES</strong> sem taxa. O valor deve valer mais do que <strong>1000 TUSD</strong>.",
    redeem_pin: "PIN de entrada",
    redeem_2fa: "2FA de entrada",
    redeem_not_allowed_today:
      "Os resgates estão disponíveis às quartas-feiras, das 00h to 17h (UTC -3).",
    redeem_not_allowed_today_1:
      "Os resgates estão disponíveis às segundas-feiras, das 00h to 17h (UTC -3).",
    redeem_not_allowed_today_2:
      "Os resgates estão disponíveis às terças-feiras, das 00h to 17h (UTC -3).",
    redeem_not_allowed_today_3:
      "Os resgates estão disponíveis às quartas-feiras, das 00h to 17h (UTC -3).",
    redeem_not_allowed_today_4:
      "Os resgates estão disponíveis às quintas-feiras, das 00h to 17h (UTC -3).",
    redeem_not_allowed_today_5:
      "Os resgates estão disponíveis às sextas-feiras, das 00h to 17h (UTC -3).",
    redeem_not_allowed_today_6:
      "Os resgates estão disponíveis aos sábados, das 00h to 17h (UTC -3).",
    redeem_not_allowed_today_7:
      "Os resgates estão disponíveis aos domingos, das 00h to 17h (UTC -3).",
    redeem_deleted_success: "O resgate foi cancelado com sucesso!",
    redeem_deleted_error: "Há algo errado, tente novamente mais tarde.",
    reedeem_2fa_text: `<p>O que é o 2FA e por que o devo usar?</p>
            <p>O 2FA significa a Autenticação de 2 Factores. Ele protege a sua conta combinando algo que você conhece (sua senha), com algo que você tem (como o seu telemóvel ou a sua chave de segurança).</p>
            <p>Depois de configurar o 2FA no seu telefone, você verá um código de acesso que muda constantemente. Você deve usar o código de acesso 2FA sempre que resgatar tokens; no entanto, só precisa de instalar o 2FA uma vez.</p>
            <p>Caso ainda não tenha um autenticador, por favor continue a utilizar um dos itens abaixo:</p>
            <a href=https://www.google.com/landing/2step/#tab=how-it-works target="_blank">Google Authenticator</a>
            <a href=" https://authy.com/download/" target="_blank">Authy Authenticator</a>
        `,
    tutorial_tittle: `<p style="color:#424b7d">Como depositar {coin}?</p>`,
    tutorial_deposit: `
        <p>1. Crie um endereço de depósito BLUE;</p>
        <p>2. Localize o formulário “Enviar” na carteira externa;</p>
        <p>3. Digitalize ou copie o endereço do token BLUE nesse formulário.</p><br/>
        <b>Nota:</b>
        <span>Depósitos BLUE são cobrados com uma taxa de rede de 6%, paga pelo remetente. <a href="https://bluetoken.io/fees" target="_blank" style="margin-top:0px; display: contents;">Tarifas.</a></span>
    `,
    tutorial_deposit_usdt: `
    <p>1. Crie um endereço de depósito Tether (USDT);</p>
    <p>2. Localize o formulário “Enviar” na carteira externa;</p>
    <p>3. Digitalize ou copie o endereço do Tether (USDT) nesse formulário.</p><br/>
    <b>Nota:</b>
    <span>Certifique-se de selecionar a rede Tron (TRC20).</span>
`,
    tutorial_tittle_withdraw: `<p style="color:#424b7d">Como adicionar Blue Token em carteiras externas?</p>`,
    tutorial_withdraw: `
        <p>1. Selecione Binance Smart Chain (BSC) na rede de carteira externa;</p>
        <p>2. Copie este endereço de contrato de token Blue e importe na carteira externa;</p>
    `,
    tutorial_withdraw_pt2: `
        <b>Note:</b>
        <p>- A Blue Token não assume responsabilidade por operações que ocorrem em plataformas de terceiros.</p>
        <p>- Todas as transações originadas fora de nossa plataforma são cobradas uma taxa de rede de 6%. <a href="https://bluetoken.io/fees" target="_blank" style="margin-top:0px; display: contents;">Tarifas.</a></p>
    `,
    cancel_redeem: "Cancelar Resgate",
    retry: "Repetir",
    required_fields: "Campos obrigatórios",
    recipients_user_id: "ID de usuário do destinatário.",
    required_fields_amount_uid:
      "Quantidade e UID são necessários para esta ação.",
    staking_rewards: "Recompensas de Staking",
    redeeming: "Resgatando",
    receiving: "Recebendo",

    //referral texts
    referral: "Referência",
    referral_text_1:
      "Quando você indica pessoas para comprarem BLUE, você recebe uma recompensa e essas pessoas recebem um prémio, pago em BLUE!",
    referral_text_2:
      "Dê o link ou o código de indicados aos seus familiares e amigos. As recompensas e os bónus são ilimitados. Não importa quantas vezes os seus indicados comprem BLUE. Sempre que eles comprarem, você receberá uma recompensa e eles receberão um bónus.",
    referral_text_3:
      "Para ativar o seu código de indicados, primeiro tem de comprar BLUE. Depois de comprar os BLUE, volte a esta página e comece a utilizar o seu código de indicados.",
    review_your_purchase: "Reveja a Sua Compra",
    reward: "Recompensa",
    rows_per_page: "Linhas por página",
    redeemed_value: "Valor resgatado",

    //s
    save: "Salvar",
    send: "Enviar",
    settings: "Definições",
    header_settings: "Configurações",
    signup: "Inscreva-se",
    something_went_wrong: "Algo correu mal",
    subtotal: "Subtotal",
    send_to_btc_adress: "Endereço de destino",
    send_to_btc_adress_destination: "Endereço de destino Bitcoin",
    send_to_blu_adress: "<strong>BLUE</strong> Endereço de destino",
    send_to_blu_adress_on: "<strong>BLUE</strong> Endereço de destino activado",
    allowed_wallets: "*Carteiras aceitas:",
    step_1_withdraw_blue: "1. Selecione a carteira desejada para sacar.",
    step_2_withdraw_blue:
      "2. Clique para copiar o endereço do contrato do Blue Token na Binance Smart Chain:",
    step_3_withdraw_blue:
      '3. Clique para importar automaticamente o token do Blue na <a href="https://bit.ly/3wMClbk" target="_blank">Metamask</a>',
    step_3_withdraw_blue_p2:
      "siga as instruções para adicionar manualmente o token do Blue na: ",
    or: "ou",
    contract_address: "0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2",
    success: "Sucesso",
    success_create_wallet: "Endereço criado com sucesso",
    session_expired: "Sessão expirada. Por favor faça login novamente",
    services: "Serviços",
    staking_APY: "Estacando APY",
    submit: "Enviar",

    months: {
      1: "Janeiro",
      2: "Fevereiro",
      3: "Março",
      4: "Abril",
      5: "Maio",
      6: "Junho",
      7: "Julho",
      8: "Agosto",
      9: "Setembro",
      10: "Outubro",
      11: "Novembro",
      12: "Dezembro"
    },
    

    //pool
    pool: "Pool",
    join_pool: "Registre-se e ganhe",
    monthly_rewards: "Recompensas do Pool de {month}",
    my_rewards: "Estimativa das minhas recompensas",
    qualification_status: "Status de qualificação",
    need_to_qualify: "Precisa de",
    to_qualify: "para se qualificar",
    calculating: "calculando...",
    posted_soon: "O Pool está sendo calculado e será postado em breve.",
    nobody_qualified:
      "Ninguém se qualificou ainda para ganhar as recompensas do pool. Seja o primeiro e ganhe!",
    leaderboard: "Tabela dos líderes",
    last_month_winners: "Vencedores do mês passado",
    referral_volume: "Volume de indicaçoes",
    reward_pool: "% de Recompensa",
    estimated_pool: "Estimativa",
    view_all: "Ver tudo",

    modal_pool_title: "Recompensas da Blue Pool",
    modal_pool_text:
      "Todos os meses, um pool é criado para recompensá-lo pelas compras de sua indicação. Os participantes que acumularem 1 token BLUE ou mais em compras de referência ganham automaticamente uma parte do pool. <a href=https://youtu.be/D8P1_01-uF4 target=_blank style='width:auto'>Assista o tutorial</a>",
    modal_pool_important: "Importante",
    modal_pool_text2: "Para participar, você deve primeiro cria seu avatar.",
    modal_pool_text3: "Seu avatar não pode ser mudado no futuro.",
    modal_pool_nick: "Crie um apelido",
    modal_pool_nick_span:
      "Para proteger sua privacidade, aconselhamos que não use seu nome verdadeiro.",
    modal_pool_avatar: "Selecione Avatar",
    modal_pool_btn: "PARTICIPAR",

    modal_pool_welcome: "Bem-vindo à Blue Pool",
    modal_pool_span:
      "Quando suas referências acumularem 1 BLUE em compras, seu avatar vai mostrar na tabela dos líderes, garantindo uma parte na pool.",
    modal_pool_span2: "Quanto mais eles comprarem, maior será sua parte!",
    modal_pool_referral: "Seu ID de indicação:",
    modal_pool_referral_link: "Seu link de indicação",
    modal_pool_close: "FECHAR",

    street_name: "Nome da Rua",
    state: "Distrito",
    select_partner: "Selecione um parceiro",
    start_withdrawal: "Começar Levantamento",
    start_internal_transfer: "Iniciar transferencia interna",
    send_exactly: "Enviar exatamente para o seguinte endereço:",
    seller_buy:
      "Compre como membro pretendido, bastando fornecer o UID e a quantidade.",
    sector: "Setor",

    //steps_text
    step_amount: "Montante",
    step_recipient: "Recebedor",
    step_verification: "Verificação",
    step_authentication: "Autenticação",

    //status
    status_new: "Novo",
    status_waiting: "A aguardar",
    status_processing: "A processar",
    status_done: "Terminado",
    status_failed: "Falhou",
    status_cancelled: "Cancelado",
    status_denied: "Negado",
    status_expired: "Expirado",
    status_queued: "A aguardar vez",

    //t
    tag: "ID da tag",
    tag_important:
      "Certifique-se de definir o correcto ID da tag, para garantir que o valor seja enviado para o seu endereço.",
    terms_and_conditions: "Termos e Condições",
    tokens_go_on_sale: "BLUE à venda",
    token_presale: "Pré-venda",
    token_distribution: "Distribuição",
    total: "Total",
    total_debit: "Débito Total",
    total_received: "Total Recebido",
    total_to_pay: `Total a pagar`,
    total_to_transfer: "Total a enviar",
    transaction: "Transacção | Transacções",
    transaction_completed: "Transacção Concluída",
    transaction_details: "Detalhes da Transacção",
    type: "Tipo",
    token: "Token",
    token_info: "Informação",
    token_supply: "Fornecimento",
    token_nav: "NAV",
    fund_value: "Valor do Fundo",
    token_price: "Preço",
    transaction_with_wrong_status: "Transacção com status incorrecto",
    trade_not_found: "Resgate não encontrado. Comece de novo.",
    transfers: "Transferências",
    total_redeem: "Total em BLUE",
    total_redeem_USDT: "Total em USDT",
    total_plus_block: "Disponível + bloqueado",
    token_supply_equivalence: "Equivalência de fornecimento de token em",
    transaction_failed_step:
      "A transacção falhou no passo {step}, se tiver alguma dúvida, entre em contacto com o suporte em support@bluetoken.io",
    transfer_blu_stx:
      "Envie os seus tokens BLUE para <span class='custom_highlight'>StratumX.io</span>. Use para trocar BLUE por outras criptos.",
    transfer_blu_stratum:
      "Envie os seus tokens BLUE para o SmartWallet. Use para vender BLUE, pagar contas e outros serviços.",
    transfer_blu_stratum_withdraw_sw:
      "Envie seus tokens BLUE a Stratum Advanced Wallet e desfrute de muitos benefícios.",
    tag_text:
      "O TAG é um identificador exclusivo para o reconhecer e disponibilizado pelo parceiro de levantamento. O TAG está localizado na página de depósito da carteira do parceiro.",
    table_failed_1: "* Pedidos incompletos",
    table_failed_2:
      "* Todos os pedidos incompletos serão cancelados automáticamente.",
    thank_you: "Obrigado",
    temporarily_unavailable: "Temporariamente indisponível.",
    tether_info:
      "Envie através da Rede Tron (TRC20), ou use seu saldo disponível.",
    token_type: "Tipo de token",
    today: "Hoje",
    bep20: "BEP20 (Binance Smart Chain)",
    decentralized_ex: "Decentralized Exchanges (DEX)",
    metaverse: "Metaverso",
    lending: "Empréstimos",
    payments: "Pagamentos",
    native: "Nativo",
    erc20: "ERC20 (Ethereum)",
    todays_market: "Mercado de hoje",
    token_supply: "Fornecimento de tokens",
    tks_your_payment: "Obrigado pelo seu pagamento.",
    wait_create_tokens:
      "Aguarde alguns minutos enquanto criamos seu(s) token(s).",

    //tickers
    BLU: "BLUE",
    BTC: "Bitcoin",
    ETH: "Ethereum",
    TUSD: "TrueUSD",

    //transaction tables tabelas de transacção
    createdAt: "Criado a",
    updatedAt: "Atualizado a",
    status: "Status",
    done: "Concluído",
    pre_done: "Concluído",
    failed: "Falhou",
    new: "Novo",
    processing: "A Processar",
    txid: "TX ID",
    start_date: "Data de Início",
    end_date: "Data Final",

    //u
    use_all: "Usar todos",
    userid: "ID de utilizador",
    user: "Utilizador",
    use: "Usar",
    user_id_inportant:
      "Tenha atenção ao inserir o ID de usuário, assim como a quantidade que você quer enviar para a conta correta",

    //v
    value: "Valor",
    view_all_transactions: "Ver todas as transações",
    view_reward_bonus_schedule: "Visualizar agendamento de recompensas e bónus",
    view_status: "Exibir status",
    voting_info_1:
      "É hora de votar em 2 criptomoedas para adicionar (ou manter) como parte da cesta BLUE para o primeiro trimestre (T1) de 2023.",
    voting_info_2:
      "Ultimamente, os reguladores governamentais procuram empresas de criptomoedas que oferecem retornos sobre arbitragem e atividades semelhantes. A conformidade com os reguladores comprometeria a privacidade dos nossos utilizadores. Como sabe, aqui na Stratum, a privacidade e segurança dos nossos utilizadores sempre foram a nossa principal preocupação. Decidimos então remover essas atividades do nosso portfólio para evitar a conformidade e basear o BLUE no valor de 14 criptomoedas em vez de 12.",
    voting_info_3:
      "Basta clicar no botão abaixo e selecionar 2 criptomoedas. Votaçao não é obrigatória mas incentivamos. Acreditamos que qualquer uma das opções fornecidas será uma adição promissora à cesta. Contaremos os votos de acordo com o número de BLUE em sua conta (cada BLUE completo em sua conta dá a você 1 voto). A votação estará disponível até 30 de Dezembro às 23:59h (UTC -3).",
    voting_info_4:
      "Adicionaremos mais detalhes sobre essa alteração num relatório atualizado no nosso site, como a frequência de votação e a sua futura implementação usando o blockchain.",
    vote_bellow: "Vote abaixo",
    vote_success: "Votado com sucesso, obrigado!",
    voting_survey: "Pesquisa de votação",
    verify_step: "Verifique seu resgate",
    view_other_currencies: "Ver outras moedas",
    verify_your_withdraw: "Verifique sua retirada",

    //w
    waiting: "A Processar",
    welcome: "Bem-vindo",
    with: "com",
    withdraw: "Levantamento",
    withdraws: "Levantamentos",
    withdraw_amount: "Valor de levantamento",
    withdraw_transfer: "Levantamento",
    was_referred:
      "Peça ao seu amigo o código de indicação para ganhar recompensas, ou deixe em branco para doar para Bitgive e B4H.",
    waiting_for_aprove: "Em Ordem",
    waiting_aprove_info:
      "Os fundos só ficam disponíveis 60 dias após cada compra que faça",
    w: "W",
    withdraw_sub:
      "O levantamento é uma operação que permite enviar BLUE para um endereço de carteira BLUE válido e compatível.",
    withdraw_sub_usdt: `O levantamento é uma operação que permite enviar USDT para um e endereço de carteira USDT compatível.`,
    withdraw_network_fee: "Para saques existe o network fee de 0.0005 btc",
    we_accet: "Nós aceitamos",
    why_change: "Porquê a mudança",
    white_paper: "Relatório",
    withdrawal_steps: "Etapas de levantamento",
    withdrawal: "Levantamento",
    withdrawing: "Retirada",

    //y
    you_will_receive: "Você receberá",
    your_email_shortly: "O seu E-mail deve chegar brevemente",
    you_want_start_new_purchase:
      "Você está cancelando um pedido de depósito, se quiser fazer um novo, reinicie o fluxo de compra.",
    you_must_accpet_terms:
      "Você deve concordar com nossos termos e condições para continuar. Se você tiver alguma dúvida, entre em contato com support@bluetoken.io.",
    you_must_accpet_privacy:
      "Você deve concordar com a nossa política de privacidade para continuar. Se você tiver alguma dúvida, entre em contato com support@bluetoken.io.",
    yes: "Sim",
    no: "Não",

    //newBuyTexts
    beforeSendUnderTitle:
      "Selecione a quantidade de BLUE que deseja comprar. O pagamento tem de ser feito com cripto.",
    amount_in: "Montante em",
    estimated_amount_in: "Montante estimado em",
    important: "importante",
    below_button_1:
      "- A quantidade de BLUE a ser creditada, depende da quantidade de criptos que vai receber. Esteja ciente de quaisquer taxas que o seu provedor de carteira pode cobrar pela transferência. Essas taxas diminuirão a quantidade de criptos e por consequência diminuirão também a quantidade de tokens.",
    below_button_2:
      "- Se a quantidade de BTC que recebemos estiver abaixo do mínimo exigido (0.0208 BTC), o seu BTC será adicionado a um saldo temporário, que você poderá usar num novo pedido. ",
    understand_and_agree:
      "Entendo que qualquer valor acima do mínimo enviado para o nosso endereço de pagamento, será automaticamente convertido em BLUE. ",
    i_understand: "Eu entendo",
    understand_and_agree_button: "Eu entendo e Concordo",
    understand_and_agree_warning:
      "O tempo de compra é entre as 9:00h e as 17:00h (GMT-3), de segunda-feira a sexta-feira. As transacções realizadas fora desse período serão processadas no dia seguinte.",
    waiting_deposit: "A aguardar depósito",
    waiting_deposit_otc: `Aguardando confirmação de OTC`,
    transaction_details: "Detalhes da transacção",
    transaction_failed_1: "A transacção falhou no passo",
    transaction_failed_2:
      "Se tiver alguma dúvida, entre em contacto com o suporte em support@bluetoken.io",
    temporary_balance: "Saldo Temporário",
    temporary_balance_substracted:
      "Este saldo temporário é deduzido do valor total a ser enviado.",
    to_send: "A enviar",
    to_receive: "A receber",
    received: "Recebido",
    expected: "esperado",
    expected_amount_in: "Montante esperado em",
    estimated_blu: "BLUE estimado",
    estimated: "estimado",
    earned_pool: "Recebido",
    waiting_deposit_undertext:
      "O valor do BLUE será confirmado após a confirmação do pagamento na Blockchain.",
    processing_order: "Ordem de processamento",
    confirmed_amoutn: "Montante confirmado",
    follow_transaction_text: "Siga a Transacção",
    check_transaction_status: "Verifique o status da sua operação",
    new_operation: "Nova Operação",
    order_created: "Ordem Criada",
    confirmed_on_blockchain: "Confirmado na blockchain",
    order_completed: "Ordem completa",
    order_completed_info:
      "O seu BLUE está a ser criado. Você receberá um certificado por e-mail quando o processo estiver concluído.",
    order_completed_info_title: "Terminado",
    temporary_balance_warning:
      "Lembre-se de que você tem um saldo temporário de transacções anteriores que será adicionado à sua transferência..",
    send_btc_to_address:
      "Para receber os seus BLUE, envie a sua {coin} para este endereço",
    purchase_confirmation: "Confirmação de Compra",
    min: "min",
    btc_sent: "BTC Confirmado",
    blu_confirmed: "BLUE Confirmado",
    minimum_amount_required: "O montante tem de estar acima do mínimo.",
    check_open_orders: "Verifique a ordem em aberto",
    make_new_order: "Faça uma nova ordem",
    if_no_order:
      "Se não aparecer nenhuma ordem por um longo período, por favor verifique se realmente fez a ordem. Se necessário, faça uma nova.",
    confirmed: "Confirmado",
    waiting: "A aguardar",
    action_blocked_purchase:
      "Neste momento o nosso sistema encontra-se em manutenção. Por favor tente fazer a sua compra mais tarde.",
    bktc_text:
      "O banco para Cripto permite que consiga comprar rapidamente Bitcoin.",
    bktc_text2: "Para prosseguir com a sua transacção, pague com a Fiat abaixo",
    bktc_only_brazil:
      "Por favor tenha em atenção que este método de pagamento só deve ser utilizado por clientes brasileiros.",
    info_link_stratum_wallet: "Para comprar criptos aceda à sua SmartWallet.",
    select_coin_payment: "Selecione um Método de Pagamento",

    //other long phrases
    your_id_is:
      "O seu ID é o código de 6 dígitos enviado para o seu e-mail na inscrição.",
    amount_too_small:
      "O montante é muito baixo. A compra mínima é de 100 TUSD.",
    aware_token_redeem:
      "Estou ciente que os tokens não podem ser transferidos até 60 dias após a compra.",
    click_here_phases: "Para mais detalhes sobre cada fase, clique aqui",
    create_new_email_recommendation: `Para cada plataforma, recomendamos que crie um novo e-mail <span class="text_highlight"> Este e-mail será usado para receber as suas informações de login e outras comunicações internas.</span>`,
    current_presale_ends: "A fase atual de Pré.Venda 3, termina a 6 de Abril",
    did_someone_referred: "Alguém o indicou? (Opcional)",
    i_read_and_accept:
      'Li e aceito <a href="/terms" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Termos e Condições</a> e a <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Política de Privacidade</a>.',
    // i_read_and_accept_policy:
    //   'Li e aceito a <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Política de Privacidade</a>.',
    i_read: "Li e aceito os Termos e Condições.",
    i_read_privacy: "Li e aceito os Política de Privacidade.",
    not_usa_citizen:
      "Declaro que não sou cidadão ou residente nos Estados Unidos da América.",
    not_china_citizen: "Declaro que não sou cidadão ou residente em Hong Kong.",
    scan_qr_code_or_copy_address: "Digitalize o código QR ou copie o endereço.",
    warning_60days:
      "Os resgates e levantamentos não estão disponíveis até 60 dias após a compra. Se não tiver interesse em comprar tokens, não envie o pagamento.",
    //portfolio
    portfolio_intro:
      "A nossa cesta de criptomoedas é feita a partir de um conjunto selecionado de criptomoedas com confiança de mercado verificado ou grande potencial de crescimento.",
    text_LUNA:
      "Terra é um protocolo blockchain que usa stablecoins indexados em fiat para alimentar sistemas de pagamentos globais com preços estáveis.",
    text_BTC:
      "É a criptomoeda com a maior capitalização de mercado. Usada para pagamentos e reserva de valor.",
    text_ETH:
      "É a primeira plataforma de criptomoedas a criar contratos inteligentes e aplicações descentralizadas.",
    text_XRP:
      "O XRP é utilizado por bancos e empresas para liquidez e transferências de liquidações.",
    text_LTC:
      "Conhecida como a prata para o Bitcoin Gold. Nos primeiros dias de cripto, o Litecoin foi criado para ser uma versão mais rápida e mais económica do Bitcon.",
    text_BCH:
      "O Bitcoin Cash foi criado a partir de um fork do Bitcoin (divisão de moeda). É uma versão modificada do Bitcoin que realiza transacções mais rápidas e mais económicas.",
    text_EOS:
      "Plataformas para criar aplicações descentralizadas, sem taxas de transacção.",
    text_XLM:
      "Os lúmens são usados para remessas, permitindo acordos entre diferentes moedas.",
    text_ADA:
      "Projecto que visa desenvolver a mais avançada plataforma de contracto inteligente. A sua equipa consiste num grande conjunto global de engenheiros e pesquisadores especializados, incluindo Charles Hoskinson, co-fundador da Ethereum.",
    text_BNB:
      "É um token digital criado pela plataforma de negociação Binance, fornecendo vários benefícios aos seus comerciantes.",
    text_TRX:
      "É uma plataforma descentralizada para partilhar e monetizar entretenimento digital.",
    text_ZCR:
      "Criptomoeda criada para simplificar pagamentos. Os serviços que usam o Zcore incluem um sistema móvel de mensagens e masternode.",
    text_NXS:
      "A arquitectura avançada de blockchain da Nexus fornece a mais alta expansão e segurança. O Nexus também visa descentralizar a Internet, fornecendo acesso via satélite no espaço.",
    text_IOTA:
      "O projecto IOTA visa criar um ecossistema financeiro seguro e descentralizado para a Internet of Things (IOT).",
    text_XMR:
      "O Monero prima pela privacidade e não pela rastreabilidade. As transacções não podem ser vinculadas a um utilizador específico ou a uma identidade do mundo real.",
    text_OTC:
      "Atualmente, as Criptos incluem o SafeInsure (SINS), Zcore (ZCR), SmartCash (SMART), DashGreen (DASHG), BitTorrent(BTT), Wink (WIN) e o Bitcoin (BTC) .",
    text_DASH:
      "É uma das criptomoedas mais conhecidas com uma vasta rede crescente de utilizadores. Presente desde os primeiros dias da criptografia, o Dash concentra-se em pagamentos rápidos e seguros.",
    text_LINK:
      "O token Ethereum alimenta a rede oracle descentralizada Chainlink, permitindo que contratos inteligentes se liguem com segurança a fontes de dados externas, APIs e sistemas de pagamentos,",
    text_LEND:
      "Token digital usado na Aave, uma das plataformas DeFi de empréstimos de crescimento mais rápido, proporcionando grandes benefícios a seus usuários.",
    text_DOT:
      "Polkadot visa facilitar uma web descentralizada totalmente funcional e amigável (Web 3.0), permitindo transferências cross-blockchain de qualquer tipo de dados ou ativos.",
    text_UNI:
      "Token de governança da Uniswap, uma das maiores plataformas descentralizadas de trading hospedadas em Ethereum, que facilita a negociação de tokens de finanças descentralizadas (DeFi).",
    text_FIL:
      "Filecoin é um sistema de armazenamento descentralizado. Ao contrário de empresas de armazenamento em nuvem como Amazon ou Cloudflare, Filecoin aproveita sua natureza descentralizada para proteger a integridade dos dados.",
    text_THETA:
      "Theta é a criptomoeda nativa da Rede Theta, um blockchain para melhorar a qualidade e capacidade de entrega de conteúdo de streaming de vídeo.",
    text_MANA:
      "Token digital usado na Decentraland, uma plataforma de realidade virtual que permite aos usuários comprar, personalizar e vender lotes de terra virtuais como NFTs.",
    text_CAKE:
      "Token de governança do PancakeSwap, a plataforma de trading descentralizada (DEX) de crescimento mais rápido hospedada na Binance Smart Chain.",
    text_MATIC:
      "Token de governança do Polygon, uma rede de segunda camada para dimensionamento e desenvolvimento de infraestrutura da Ethereum. Com o Polygon, o Ethereum torna-se um sistema multi-chain, facilitando a interoperabilidade do blockchain, com transações mais rápidas a um custo menor.",
    text_SOL:
      "Token nativo da rede Solana, um blockchain de rápido crescimento no espaço DeFi, com velocidade e escalabilidade excelentes, capaz de atingir até 65.000 transações por segundo.",
    text_CRV:
      "Token nativo da Curve Finance, a plataforma de trading descentralizada (DEX) com o maior volume atual em DeFi. O Curve Finance é único devido à sua otimização para swaps com baixo deslizamento entre stablecoins ou ativos semelhantes que atrelam ao mesmo valor.",
    text_AVAX:
      "Token nativo do Avalanche, um blockchain de contratos inteligentes emergente no DeFi e no espaço NFT.",
    text_MBOX:
      'Token de governança no Mobox, um aplicativo de jogo descentralizado "play-to-earn" que permite que os usuários negociem NFTs e sejam recompensados por sua participação.',
    text_USDT: "Stablecoin a par com o Dólar Americano.",
    text_TUSD: "Stablecoin a par com o Dólar Americano.",

    //charity text
    bitgive_info:
      "Usando a tecnologia bitcoin e blockchain para melhorar a saúde pública e o meio ambiente em todo o mundo.",
    b4h_info:
      "Apoia as organizações que usam a tecnologia blockchain para trazer uma mudança positiva à humanidade.",

    //tooltip
    tooltip_text_charity:
      "Até 50% das nossas taxas das vendas são doadas para a BitGive e Blockchain for Humanity.",
    tooltip_purchase_referral:
      "Você pode preencher este campo se alguém o ajudou na compra.",
    tooltip_internal_withdraw:
      "Este é o campo do ID de usuário do destinatário.",

    //redeem
    current_balance: "Saldo Actual",
    unlocked_balance: "Saldo desbloqueado",
    total_without_fees: "Total sem taxas",
    total_to_receive: "Total a receber",

    min_length: "O comprimento mínimo é",
    characters: "carateres",
    contact_intro:
      "Se tiver alguma dúvida ou problema que precise de resolver, entre em contacto no formulário abaixo",
    email_to_registered:
      "O e-mail será enviado para o e-mail registado na plataforma",
    subject: "assunto",
    message: "mensagem",
    form_sent: "Mensagem enviada com sucesso",
    form_error:
      "Ocorreu um erro ao enviar a sua mensagem. Por favor tente novamente mais tarde.",
    insufficient_funds: "Fundos Insuficientes",

    //modal voting coins
    coin_voting_enj:
      'Token digital usado na rede ENJIN, uma plataforma de social gaming, permitindo aos usuários monetizar itens no jogo, como NFTs. <a href="https://enjin.io/" target="_blank">Saiba mais</a>',
    coin_voting_mana:
      'Token digital usado na Decentraland, uma plataforma de realidade virtual que permite aos usuários comprar, personalizar e vender lotes de terra virtuais como NFTs. <a href="https://decentraland.org/" target="_blank">Saiba mais</a>',
    coin_voting_bat:
      'Token digital usado para recompensar usuários e editores no crescente navegador "Brave". Editores e criadores ganham receita de anúncios, bem como gorjetas, enquanto os usuários mantêm a privacidade enquanto ganham BAT para visualizar os anúncios. <a href="https://basicattentiontoken.org/" target="_blank">Saiba mais</a>',
    coin_voting_dash:
      'Uma das criptomoedas mais conhecidas com uma vasta rede crescente de usuários. O Dash se concentra em pagamentos rápidos e privados, oferecendo "PrivateSend" para ativar transações não rastreáveis. <a href="https://www.dash.org/" target="_blank">Saiba mais</a>',
    coin_voting_mkr:
      'Token digital criado pela MakerDAO, uma das maiores plataformas DeFi, que fornece empréstimos garantidos pela Ethereum. <a href="https://makerdao.com/en/" target="_blank">Saiba mais</a>',
    coin_voting_xtz:
      'Criptomoeda nativa da blockchain da Tezos, que se concentra na integração da tecnologia de Smart Contracts com produtos financeiros. Ultimamente, vários projetos NFT, como o Cleveland Cavaliers e o McLaren, estão usando o Tezos para suas coleções. <a href="https://tezos.com/" target="_blank">Saiba mais</a>',
    coin_voting_lend:
      'Token digital usado no Aave, uma das plataformas de empréstimo DeFi de crescimento mais rápido, proporcionando grandes benefícios aos usuários AAVE. <a href="https://aave.com/" target="_blank">Saiba mais</a>',
    coin_voting_atom:
      'Ecossistema de crescimento rápido de blockchains que podem escalar e interoperar entre si, concorrente de Polkadot (DOT), Ethereum (ETH) e outras importantes criptomoedas de contratos inteligentes. <a href="https://cosmos.network/" target="_blank">Saiba mais</a>',
    coin_voting_band:
      'Plataforma oracle de cross-chain data que agrega e conecta dados e APIs do mundo real a Smart Contracts. <a href="https://bandprotocol.com/" target="_blank">Saiba mais</a>',
    coin_voting_aave:
      'Token digital utilizado na AAVE, uma das maiores plataformas de empréstimo DeFi. A AAVE foi atualizada recentemente para a versão 3.0, fornecendo empréstimos "cross-chain" e um novos mecanismos para melhorar a experiência do usuário, gerenciamento de risco e eficiência de capital. <a href="https://aave.com/" target="blank_">Saiba mais</a>.',
    coin_voting_uni:
      'Uma das plataformas de negociação descentralizadas mais conhecidas, facilitando a negociação automatizada de tokens de finanças descentralizadas (DeFi). <a href="https://uniswap.org/" target="blank_">Saiba mais</a>.',
    coin_voting_fil:
      'Filecoin é um sistema de armazenamento descentralizado. Ao contrário de empresas de armazenamento em nuvem como Amazon ou Cloudflare, Filecoin aproveita sua natureza descentralizada para proteger a integridade dos dados. <a href="https://filecoin.io/" target="blank_">Saiba mais</a>.',
    coin_voting_cake:
      'Token de governança do PancakeSwap, a plataforma de trading descentralizada de crescimento mais rápido hospedada na Binance Smart Chain. <a href="https://pancakeswap.finance/" target="blank_">Saiba mais</a>.',
    coin_voting_matic: `Token de governança do Polygon, uma rede de segunda camada para dimensionamento e desenvolvimento de infraestrutura da Ethereum. Com o Polygon, o Ethereum torna-se um sistema multi-chain, facilitando a interoperabilidade do blockchain, com transações mais rápidas a um custo menor. <a href="https://polygon.technology/" target="blank_">Saiba mais</a>.`,
    coin_voting_sand: `Token de governança do The Sandbox, um mundo de realidade virtual onde as pessoas podem criar, compartilhar e vender conteúdo como NFTs, como jogos e experiências únicas. <a href="https://sandbox.game/" target="blank_">Saiba mais</a>.`,
    coin_voting_axs: `Token de governança do Axie Infinity, o jogo de realidade virtual "jogue para lucrar" de crescimento mais rápido usando NFTs. Mais de 1 milhão de jogadores ativos diariamente "batalham" no Axie Infinity pela chance de ganhar recompensas em cripto. <a href="https://axieinfinity.com/" target="blank_">Saiba mais</a>.`,
    coin_voting_mbox: `Token de governança no Mobox, um aplicativo de jogo descentralizado que permite que os usuários negociem NFTs e sejam recompensados ​​por sua participação. <a href="https://www.mobox.io/#/" target="blank_">Saiba mais</a>.`,
    coin_voting_xmr: `Criptomoeda focada em privacidade. Monero foi projetado para evitar a censura, com suas transações sendo totalmente não rastreáveis. <a href="https://monero.org" target="blank_">Saiba mais</a>.`,
    coin_voting_egld: `Elrond é uma blockchain projetada para alto rendimento e velocidade de execução rápida em comparação com outras plataformas de contrato inteligente. Para aumentar a adoção, o projeto oferece suporte aos desenvolvedores na plataforma, permitindo que eles ganhem 30% das taxas do contrato inteligente como royalties. <a href="https://elrond.com/" target="blank_">Saiba mais</a>.`,
    coin_voting_etc: `Ethereum Classic é o Ethereum original, que ainda roda com Proof of Work (mineradores). O ETC é usado para pagar pela execução de transações e funções de contrato inteligente. <a href="https://ethereumclassic.org/" target="blank_">Saiba mais</a>.`,
    coin_voting_ton: `Toncoin (TON) é uma blockchain de camada 1 descentralizada desenvolvida em 2018 pela plataforma de mensagens criptografadas Telegram. O projeto foi então abandonado, assumido pela TON Foundation e renomeado de "Telegram Open Network" para "The Open Network". <a href="https://ton.org/" target="blank_">Saiba mais</a>.`,
    coin_voting_xlm: `Stellar é uma rede de pagamentos de código aberto que serve como um blockchain intermediário distribuído para sistemas financeiros globais e circula um ativo nativo, Stellar Lumens (XLM). <a href="https://stellar.org/" target="blank_">Saiba mais</a>.`,

    modalNetwork: {
      title: "Anúncios",
      text_one: `Temos o prazer de informar que adicionamos recentemente novos recursos:`,
      title_two: "Blue Club",
      text_two: `Aos usuários que comprarem 20 BLUE tokens ou mais, ganharão um NFT como associação ao Blue Club, em que proporcionará os benefícios:`,
      text_two_t: `Você pode acompanhar o progresso de sua qualificação em seu Painel. Estamos ansiosos para recebê-lo no Blue Club!`,
      title_three: "Tether Wallets",
      text_three:
        "Agora você pode depositar e sacar Tether (USDT), oferecendo mais flexibilidade de investimento. Decida se é um bom momento para comprar e manter Blue Tokens ou manter o Tether em sua carteira para quando for a hora certa."
    },

    modalBscInfo: {
      title: "Anúncios",
      text_one: `Conforme informado anteriormente em nossos relatórios trimestrais, o BLUE estará trocando de blockchain. O token BLUE deixará o blockchain NEM, para ser hospedado no blockchain Binance Smart Chain (BSC).`,

      text_two: `A mudança está programada para quinta-feira, 11 de novembro de 2021 às 9h (UTC-3). A plataforma não estará disponível durante esta transição, que deve durar 4 dias. Esperamos ter a plataforma instalada e funcionando novamente na segunda-feira, 15 de novembro. Durante esse período, todas as operações estarão indisponíveis, portanto, planeje-se.`,

      title_two: "O preço do token e o saldo dos usuários não serão afetados.",
      text_three:
        "Os usuários terão a mesma quantidade de tokens que tinham antes da mudança. O preço do token continuará sendo rastreado pelas 14 criptomoedas em nossa cesta durante este período.",
      title_four:
        "Estamos muito entusiasmados com a mudança. O BSC permitirá uma integração mais fácil do BLUE com terceiros que desejam trabalhar com o token. O BSC está crescendo rapidamente, sendo atualmente o segundo maior blockchain usado em aplicativos DeFi. Devido às suas taxas baixas, os desenvolvedores e usuários consideram o BSC como uma alternativa mais barata ao Ethereum. Além disso, o BSC foi construído para hospedar projetos Ethereum, e é por isso que os desenvolvedores acham fácil hospedar seus projetos no Ethereum e BSC.",
      title_five:
        "Conforme prometido, estamos trabalhando constantemente para crescer o BLUE. Este movimento é um passo muito importante para a nossa expansão. Agradecemos a todos os nossos usuários que continuam apoiando o projeto."
    },

    modalBluePool: {
      title: "Announcements",
      text_one: `Atualizamos nossos termos e condições.`,
      title_one: "Taxa de compra",
      text_two: `Reduzimos a taxa de compra do token BLUE, de 6% para 2%. Isso reduzirá custos para pessoas que desejam comprar tokens BLUE pela primeira vez e para aqueles que costumam fazer contribuições mensais.`,
      title_two: "Taxa de custódia",
      text_three:
        "Aumentamos nossa taxa de custódia, de 2,5% para 6% (anual). Isso nos permitirá fornecer melhores ferramentas, serviços e segurança, além da criação de um novo sistema de recompensas.",
      title_four: "Novo sistema de recompensas: Blue Pool",
      text_four:
        "Estamos introduzindo um novo sistema de recompensas: Blue Pool. Todos os usuários agora podem participar de um pool de recompensas mensal. As recompensas são pagas aos usuários que indicam seus amigos para comprar tokens BLUE. A primeira “pool” foi fixada em 4.20 BLUE (aproximadamente $1.800 dólares). Ganhe sua parte!"
    },

    modalDhbtInfo: {
      title: "Anúncios",
      text_one: `Atualizamos nossos termos e condições.`,

      text_two: `Conforme anunciado anteriormente, o Blue Token agora é um produto de uma empresa recém-formada, a Digital Horizon Blockchain Technology, registrada no país de El Salvador.`,

      title_two:
        "A mudança se deve a vários benefícios dados por El Salvador às empresas de criptomoedas. El Salvador é o único país do mundo que aceitou o Bitcoin como moeda legal. Seu governo está incentivando as empresas de criptomoedas a investir e prosperar, preparando as bases para o crescimento futuro em inovação tecnológica e infraestrutura.",
      text_three:
        "Estamos muito animados com a mudança e prontos para aproveitar os benefícios de El Salvador para levar o Blue Token ao próximo nível.",
      title_four:
        "Se você tiver alguma dúvida, envie um email para support@bluetoken.io.",
      title_one:
        "Blue é um produto da Digital Horizon, com sede em El Salvador",
      title_five: "Pagamento e taxas de resgates",
      text_four:
        "A partir de 2 de fevereiro, todos os resgates serão pagos apenas em USDT (Tether), juntamente com alterações nas taxas de resgate:",
      text_six: `Taxa de resgate: 1% do valor de resgate <br/>Taxa mínima de resgate: 50 USDT`,
      text_seven:
        "O prazo de pagamento continuará sendo de 3 dias úteis. Os usuários terão a opção de pagamento no mesmo dia por uma taxa."
    },

    modalBuyBluePix: {
      buy_blue: "Comprar BLUE",
      connecting_swapix: "Conectando-se ao SWAPiX",
      only_accepts: "Blue Token só aceita pagamento em criptomoedas.",
      pix_purcase_processed:
        "Felizmente, as compras do Pix são processadas pelo nosso parceiro confiável SWAPiX.",
      swapix_terms: `Eu li os <a class=p5_l href=https://usdt.smartpay.com.vc/static/media/terms_jun.f681a88b.pdf target=blank style="margin-right:5px">termos e condições</a> da SWAPiX.`,
      btn_next: "Próximo",
      welcome: "Bem-vindo ao",
      payment_being_processed:
        "Suas informações de pagamento estão sendo processadas.",
      wait: "Espere alguns segundos enquanto fazemos nossa mágica…",
      payment: "Pagamento",
      convert_price: "Taxa de câmbio",
      completed_buy:
        "Sua compra foi finalizada. Em caso seu saldo não estiver atualizado, atualize a página."
    },

    modalWarnUser: {
      title: "Saque: Importante",
      warn1:
        "Certifique-se de que a carteira de recebimento seja compatível com tokens BLUE. Nem todas as carteiras BSC suportam BLUE.",
      warn2:
        "A Blue Token não assume responsabilidade por operações que ocorram em plataformas de terceiros.",
      warn3:
        "Todas as transações originadas fora de nossa plataforma incorrem em uma taxa de 6%.",
      warn4:
        "As retiradas são irreversíveis. Verifique se você está enviando seus tokens para uma parte confiável.",
      i_understand: "Eu entendi"
    },

    modalBlueClub: {
      title: "Benefícios de associação",
      subTitle:
        "Aos usuários que comprarem 20 BLUE tokens ou mais, ganharão um NFT como associação ao Blue Club, em que proporcionará os benefícios:",
      text1: `<div style="display:flex"><a href="https://solscan.io/token/AP9rP81KJzPCQFmE4fK9Ue8NWRaXZ5QbqQJn6PKhQP17" target="_blank" style="color: #cb36ee; text-decoration:underline; margin-right:5px">Blue Club NFT</a> (Token Não-fungível);</div>`,
      text2: "Acesso VIP à todos os eventos, incluindo brindes exclusivos;",
      text3: "Serviços de consultoria exclusivos;",
      text4: "Airdrops, brindes e promoções exclusivas de nossos parceiros.",
      text5: "Convite especial para eventos de networking exclusivos."
    },

    modalClainBlueClub: {
      title: "Obtenha seu Blue Club NFT",
      text2: "Parabéns! Agora você pertence ao seleto clube VIP do Blue Token.",
      text3:
        "Agora você deve reivindicar seu NFT, que lhe dará acesso a vários benefícios de associação.",
      text4: "Insira seu endereço de Solana:",
      text5: "Use uma carteira Exodus ou Phantom para armazenar seu NFT.",
      text6:
        "Para qualquer dúvida, entre em contato com nossa equipe de suporte.",

      text7: "Bem-vindo ao Blue Club!",
      text8: "Seu NFT está sendo criado. Você receberá em até 2 dias úteis.",
      text9:
        "Você receberá um e-mail de boas-vindas. Certifique-se de que não foi enviado para a caixa de spam, pois iremos mantê-lo informado sobre eventos e serviços em que você receberá tratamento VIP.",
      text10: "ÓTIMO!"
    },

    settings: {
      title: "Configurações da Conta",
      profile: "Perfil",
      security: "Segurança",
      notifications: "Notificações",

      updateInfoProfile: "Atualize suas informações básicas de perfil.",
      updateInfoSecurity: "Atualize suas informações básicas de segurança.",
      updateInfoNotifications:
        "Desative ou ative suas notificações por e-mail.",

      currently: "Atualmente",
      profileStatus: "Status do perfil",

      updateProfile:
        "Clique em Salvar para atualizar as informações do seu perfil.",
      updateSecurity:
        "Clique em Salvar para atualizar suas informações de segurança.",
      updateNotification:
        "Clique em Salvar para atualizar suas configurações de notificações.",

      toggleEmail: "Alterne suas notificações por e-mail",

      popupSure: "Tem certeza?",
      popupConfirm: "Confirme sua alteração de senha.",

      popupChangesApply:
        "As alterações serão aplicadas quando você fizer login novamente."
    }
  }
};



// WEBPACK FOOTER //
// ./src/lang/pt.js